import type { FC } from "react";

interface ArrowRigthIconProps {
  disabled?: boolean;
  hover?: boolean;
}

const ArrowRigthIcon: FC<ArrowRigthIconProps> = ({
  disabled = false,
  hover = false,
}) => {
  return (
    <div>
      <svg
        viewBox="0 0 24.00 24.00"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#000000"
        transform="matrix(1, 0, 0, 1, 0, 0)"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M10.5 9L13.5 12L10.5 15"
            stroke={disabled ? "#4d525490" : "#1C274C"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            opacity="0.5"
            d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
            stroke={disabled ? "#4d525490" : hover ? "#0052A2" : "#4d5254"}
            strokeWidth="2"
          ></path>
        </g>
      </svg>
    </div>
  );
};

export default ArrowRigthIcon;
